import { Component, computed, input, output } from '@angular/core';
import { ButtonComponent, IconComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';

export type ShipmentDetailsDownloadState = 'ready' | 'processing' | 'failed';

/** View Shipment Details toggle, projected details panel, and Print Shipment Details action. */
@Component({
  selector: 'app-get-labels-details-toggle',
  imports: [ButtonComponent, IconComponent, TranslatePipe, TypographyComponent],
  templateUrl: './get-labels-details-toggle.html',
  styleUrl: './get-labels-details-toggle.scss',
})
export class GetLabelsDetailsToggle {
  readonly expanded = input(false);
  readonly downloadState = input<ShipmentDetailsDownloadState>('ready');
  readonly expandedChange = output<boolean>();
  readonly downloadRequested = output<void>();
  protected readonly failureStatusId = 'get-labels-shipment-details-failed';
  protected readonly downloadFailed = computed(() => this.downloadState() === 'failed');
  protected readonly downloadProcessing = computed(() => this.downloadState() === 'processing');

  /**
   * Toggles the shipment-details panel open or closed.
   */
  protected onToggle(): void {
    this.expandedChange.emit(!this.expanded());
  }

  /**
   * Opens the Shipment Details print view without changing the expanded/collapsed state.
   */
  protected onDownloadDetails(): void {
    if (!this.downloadProcessing()) {
      this.downloadRequested.emit();
    }
  }
}
